import { render, staticRenderFns } from "./Face.vue?vue&type=template&id=285f661c&scoped=true&"
import script from "./Face.vue?vue&type=script&lang=js&"
export * from "./Face.vue?vue&type=script&lang=js&"
import style0 from "./Face.vue?vue&type=style&index=0&id=285f661c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285f661c",
  null
  
)

export default component.exports